import React, { useState, useEffect } from "react";
import { ChatAvatar } from "./ChatAvatar";
import { ChatInputComponent } from "./ChatInputComponent";
import { PatientChatBubble } from "../../common/stickyChat/StickyChat";
import PatientLoader from "../../common/PatientLoader";
import { ReactComponent as CloseIcon } from "../../../assets/icons/CircleCloseIcon.svg";
import { ReactComponent as PersonIcon } from "../../../assets/icons/Person.svg";
import RiskPill from "../../common/RiskPill";
import moment from "moment-timezone";
import {
  capitalizeText,
  getInitials,
  getToday,
  urlify,
} from "../../../util/helpers";
import { useNavigate } from "react-router-dom";
import { Lightbox } from "react-modal-image";

export const TimeDivider = (time, showToday = false, isMini = "") => {
  let today = getToday();
  today = moment(today).format("MMMM DD, yyyy");
  time = new Date(time);
  time = moment(time).format("MMMM DD, yyyy");
  if (time === today || showToday) {
    time = "Today";
  }
  const timeDivider = document.createElement("div");
  timeDivider.className = `time-divider${isMini}`;
  timeDivider.innerHTML = `<hr/><small>${time}</small>`;
  return timeDivider;
};
export const TimeDividerSticky = ({ date, isToday }) => {
  return (
    <div className="time-divider">
      {isToday ? "Today" : moment(date).format("MMMM DD, YYYY")}
    </div>
  );
};
export const generateRTMUI = (
  name,
  type,
  message,
  dp = null,
  message_time = null,
  handlePreview = null
) => {
  const messageUI = document.createElement("div");
  if (!message_time) {
    message_time = new Date();
  }

  function handleImageClick() {
    console.log("handlePreview",handlePreview)
    console.log("message?.text",message?.text)
    if(handlePreview)
      handlePreview(message?.text);
    // else{
    //   setPreviewURL(message?.text)
    // }
  }

  if (!dp) {
    dp = `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(name)}`;
  }
  messageUI.className = "chat-container";
  messageUI.style.cssText = `flex-direction: row${
    type === "outgoing" && "-reverse"
  }`;
  messageUI.innerHTML = `<img alt="User's avatar" src="${dp}" style="height: 40px; width: 42px; border-radius: 100%;">`;

  if (message?.messageType === "TEXT") {
    if (message?.text.includes("http")) {
      if (message?.text.includes("chathistoryimages")) {
        messageUI.innerHTML += `<div class="${type}-chat"><small>${name}</small><img src="${message?.text?.replace(/\[.*?\]/g, '').trim()}"/></div>`;
      } else {
        messageUI.innerHTML += `<div class="${type}-chat"><small>${name}</small><span>${urlify(
          message?.text?.replace(/\[.*?\]/g, '').trim()
        )}</span></div>`;
      }
    } else {
      messageUI.innerHTML += `<div class="${type}-chat"><small>${name}</small><span>${message?.text?.replace(/\[.*?\]/g, '').trim()}</span></div>`;
    }
  } else {
    messageUI.innerHTML += `<div class="${type}-chat"><small>${name}</small><img src="${message?.text?.replace(/\[.*?\]/g, '').trim()}"/></div>`;
  }
  messageUI.innerHTML += `<span class="timestamp">${moment(message_time).format(
    "hh:mm A"
  )}</span>`;

  if (message?.messageType !== "TEXT") {
    messageUI.addEventListener("click", handleImageClick);
  }

  return messageUI;
};
export const generateRTMUI1 = (
  name,
  type,
  message,
  dp = null,
  message_time = null,
  handlePreview = null
) => {
  if (!message_time) {
    message_time = new Date();
  }

  if (!dp) {
    dp = `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(name)}`;
  }

  const handleImageClick = () => {
    if (handlePreview) {
      handlePreview(message?.text);
    }
  };

  return (
    <div
      className="chat-container"
      style={{ flexDirection: type === "outgoing" ? "row-reverse" : "row" }}
    >
      <img
        alt="User 's avatar"
        src={dp}
        style={{ height: "40px", width: "42px", borderRadius: "100%" }}
      />
      {message?.messageType === "TEXT" ? (
        message?.text.includes("http") ? (
          message?.text.includes("chathistoryimages") ? (
            <div className={`${type}-chat`}>
              <small>{name}</small>
              <img src={message?.text?.replace(/\[.*?\]/g, "").trim()} />
            </div>
          ) : (
            <div className={`${type}-chat`}>
              <small>{name}</small>
              <span
                  dangerouslySetInnerHTML={{
                    __html: urlify(message?.text?.replace(/\[.*?\]/g, "").trim()),
                  }}
                />

            </div>
          )
        ) : (
          <div className={`${type}-chat`}>
            <small>{name}</small>
            <span>{message?.text?.replace(/\[.*?\]/g, "").trim()}</span>
          </div>
        )
      ) : (
        <div className={`${type}-chat`}>
          <small>{name}</small>
          <img
            src={message?.text?.replace(/\[.*?\]/g, "").trim()}
            onClick={handleImageClick}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
      <span className="timestamp">
        {moment(message_time).format("hh:mm A")}
      </span>
    </div>
  );
};

const ChatTexting = ({
  name,
  risk,
  patientID,
  providerData,
  closeChat,
  singleChatLoading,
  sendMessage,
  inChatMessage,
  setInChatMessage,
  clinicianChatMessage,
  setClinicianChatMessage,
  chatHistory = null,
  chatData = {},
  setLatestMessage = null,
}) => {
  const navigate = useNavigate();
  const [previewURL, setPreviewURL] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [lastKnownDate, setLastKnownDate] = useState(new Date());
  const todays = getToday();

  const handlePreview = (url) => {
    setPreviewURL(url);
  };

  useEffect(() => {
    if (previewURL) {
      setShowPreview(true);
    } else {
      setShowPreview(false);
    }
  }, [previewURL]);

  useEffect(() => {
    const chatContainer = document.getElementById("chat-message-container");
    if (chatHistory) {
      let seenToday = false;
      chatHistory?.reverse()?.forEach((each) => {
        const condition2 =
          moment(new Date(each?.created))?.format("MMMM DD, yyyy") !==
          moment(lastKnownDate)?.format("MMMM DD, yyyy");

        const condition3 =
          moment(new Date(each?.created))?.format("MMMM DD, yyyy") ===
          moment(todays)?.format("MMMM DD, yyyy");

        if (!lastKnownDate || condition2) {
          setLastKnownDate(new Date(each?.created));
          chatContainer.appendChild(TimeDivider(each?.created));
        }

        if (!seenToday && condition3) {
          seenToday = true;
          setLastKnownDate(new Date(each?.created));
          chatContainer.appendChild(TimeDivider(each?.created, true));
        }
        const message = {
          messageType: each?.message_type?.toUpperCase(),
           text: each?.message,
          //text: each?.message.replace(/\[.*?\]/g, '').trim(),
        };
        let dp = null;
        if (each?.type === "incoming") {
          if (chatData?.profile_picture) {
            dp = chatData?.profile_picture;
          }
        }
        let staffName = ""
        if (each?.type === "outgoing"){
          // console.log("message?text", message?.text)
          const tempMessage = String(message?.text);
          const match = tempMessage.match(/\[From\s*:\s*(.*?)\]/);
          if (match) {
            staffName = match[1];
            // console.log("Extracted name:", staffName);
          }
        }
        const sender = each?.type === "outgoing" ? staffName : each?.sentBy;
        // console.log("sender", sender)
        // console.log("each?.sentBy", each?.sentBy)
        // console.log("each?.type", each?.type)
        const messageUI = generateRTMUI(
          //each?.sentBy,
          sender,
          each?.type,
          message,
          dp,
          each?.created,
          handlePreview
        );
        chatContainer.appendChild(messageUI);
      });
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [chatHistory]);

  useEffect(() => {
    if (inChatMessage) {
      const chatContainer = document.getElementById("chat-message-container");

      //* Append the new message to UI and scroll down.
      const messageUI = generateRTMUI(name, "incoming", inChatMessage);
      const today = moment(getToday()).format("MMMM DD, yyyy");
      if (chatContainer) {
        if (moment(lastKnownDate).format("MMMM DD, yyyy") !== today) {
          setLastKnownDate(today);
          chatContainer.appendChild(TimeDivider(today));
        }
        chatContainer.appendChild(messageUI);
        chatContainer.scrollTop = chatContainer.scrollHeight;
        setInChatMessage(null);
      }
    }
  }, [inChatMessage]);

  useEffect(() => {
    if (clinicianChatMessage) {
      const chatContainer = document.getElementById("chat-message-container");
      console.log("clinicianChatMessage",clinicianChatMessage)
      //* Append the new message to UI and scroll down.
      const messageUI = generateRTMUI(providerData?.name, "outgoing", {
        messageType: clinicianChatMessage?.messageType.toUpperCase(),
        text: clinicianChatMessage?.text,
      });
      const today = moment(getToday()).format("MMMM DD, yyyy");
      if (chatContainer) {
        if (moment(lastKnownDate).format("MMMM DD, yyyy") !== today) {
          setLastKnownDate(today);
          chatContainer.appendChild(TimeDivider(today));
        }
        chatContainer.appendChild(messageUI);
        chatContainer.scrollTop = chatContainer.scrollHeight;
        setClinicianChatMessage(null);
      }
    }
  }, [clinicianChatMessage]);

  return (
    <div
      className="col-sm-12 col-md-6 col-lg-6"
      style={{ borderleft: "1px solid lightgray" }}
    >
      {singleChatLoading ? (
        <PatientLoader />
      ) : (
        <>
          {showPreview && (
            <Lightbox
              medium={previewURL}
              small={previewURL}
              large={previewURL}
              hideZoom={true}
              onClose={() => {
                setPreviewURL(null);
              }}
            />
          )}

          <div className="chat-tile w-100 d-flex justify-content-start">
            {/* <ChatAvatar name={name} padding="25px 25px" /> */}
            <img
              alt="User's avatar"
              src={
                chatData?.profile_picture
                  ? chatData?.profile_picture
                  : `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
                      name
                    )}`
              }
              style={{
                height: "50px",
                width: "56px",
                borderRadius: "100%",
              }}
            />
            <div
              className="px-2 container-fluid"
              style={{ margin: "0px", width: "100%" }}
            >
              <div
                className="d-flex"
                style={{ gap: "10px", cursor: "pointer" }}
                onClick={() => {
                  navigate(`/patients/${patientID}`);
                }}
              >
                <>
                  <label>{capitalizeText(name)}</label>
                  <RiskPill
                    type={risk}
                    icon_height="10px"
                    icon_width="10px"
                    icon_styles={{ marginTop: "3px" }}
                    styles={{ fontSize: "0.75rem" }}
                  />
                </>
              </div>
              <small>
                <PersonIcon /> {providerData?.name} ({providerData?.type})
              </small>
            </div>
            <div className="d-flex justify-content-end">
              <CloseIcon onClick={closeChat} style={{ cursor: "pointer" }} />
            </div>
          </div>
          <div className="chat-body">
            <div className="chat-message-container" id="chat-message-container">
              <div id="lastelement" />
            </div>
            <ChatInputComponent
              sendMessage={sendMessage}
              setClinicianChatMessage={setClinicianChatMessage}
              clinicianId={providerData?.clinicianId}
              peerID={patientID}
              patientEmail={chatData?.email}
              setLatestMessage={setLatestMessage}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(ChatTexting);
